import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[cvaStandaloneTrimSpaces]'
})
export class CvaTrimSpacesDirective {

  constructor(private el: ElementRef, private control: NgControl) {
  }

  @HostListener('blur') onBlur() {
    const trimmedValue = this.el.nativeElement.value.trim();
    this.el.nativeElement.value = trimmedValue;
    if (this.control) {
      this.control.control?.setValue(trimmedValue);
    }
  }

}
